import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReportQualityBar } from './components/ReportQualityBar';
import { Toaster } from './components/ui/sonner';

// Pages
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import PerformanceInsightsPage from "./pages/PerformanceInsightsPage";
import BenchmarkIntelligencePage from "./pages/BenchmarkIntelligencePage";
import ImpactIntelligencePage from "./pages/ImpactIntelligencePage";
import ResourcesPage from "./pages/ResourcesPage";
import ContactPage from "./pages/ContactPage";
import DashboardPage from "./pages/DashboardPage";
import ReportPage from "./pages/ReportPage";
import DigitalMaturityPage from "./pages/DigitalMaturityPage";
import SolutionProviderPage from "./pages/SolutionProviderPage";
import DataMaturityPage from "./pages/DataMaturityPage";
import KPIScorecardPage from "./pages/KPIScorecardPage";
import AIMaturityPage from "./pages/AIMaturityPage";
import SustainabilityPage from "./pages/SustainabilityPage";
import BPCMAssessmentPage from "./pages/BPCMAssessmentPage";
import MultiAgentDashboard from "./pages/MultiAgentDashboard";
import CyberSecurityPage from "./pages/CyberSecurityPage";
import DiagnosticPage from "./pages/DiagnosticPage";
import PoPLanding from "./pages/pop/PoPLanding";
import PoPAuthCallback from "./pages/pop/PoPAuthCallback";
import PoPOnboarding from "./pages/pop/PoPOnboarding";
import PoPDashboard from "./pages/pop/PoPDashboard";
import PoPDirectory from "./pages/pop/PoPDirectory";
import PoPOpportunities from "./pages/pop/PoPOpportunities";
import PoPAdmin from "./pages/pop/PoPAdmin";
import PoPMessages from "./pages/pop/PoPMessages";
import PoPEvents from "./pages/pop/PoPEvents";
import PoPLibrary from "./pages/pop/PoPLibrary";
import PoPLearning from "./pages/pop/PoPLearning";
import PoPQuestions from "./pages/pop/PoPQuestions";
import PoPGaps from "./pages/pop/PoPGaps";
import PoPBooks from "./pages/pop/PoPBooks";
import PoPAIEnabledMBA from "./pages/pop/PoPAIEnabledMBA";
import CapstoneDashboard from "./pages/pop/capstone/CapstoneDashboard";
import CapstoneNew from "./pages/pop/capstone/CapstoneNew";
import CapstoneWorkspace from "./pages/pop/capstone/CapstoneWorkspace";
import CapstoneAdmin from "./pages/pop/capstone/CapstoneAdmin";
import CILanding from "./pages/ci/CILanding";
import CIDashboard from "./pages/ci/CIDashboard";
import CINewAssessment from "./pages/ci/CINewAssessment";
import CIWorkspace from "./pages/ci/CIWorkspace";
import CICompare from "./pages/ci/CICompare";
import { CIShell } from "./components/ci/CIShell";
import { PoPAuthProvider } from "./context/PoPAuthContext";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ReportQualityBar />
        <Toaster position="bottom-right" />
        <PoPAuthProvider>
          <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/performance-insights" element={<PerformanceInsightsPage />} />
          <Route path="/benchmark-intelligence" element={<BenchmarkIntelligencePage />} />
          <Route path="/impact-intelligence" element={<ImpactIntelligencePage />} />
          <Route path="/resources" element={<ResourcesPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/report" element={<ReportPage />} />
          <Route path="/digital-maturity" element={<DigitalMaturityPage />} />
          <Route path="/solution-provider" element={<SolutionProviderPage />} />
          <Route path="/data-maturity" element={<DataMaturityPage />} />
          <Route path="/kpi-scorecard" element={<KPIScorecardPage />} />
          <Route path="/ai-maturity" element={<AIMaturityPage />} />
          <Route path="/sustainability" element={<SustainabilityPage />} />
          <Route path="/bpcm-assessment" element={<BPCMAssessmentPage />} />
          <Route path="/multi-agent-dashboard" element={<MultiAgentDashboard />} />
          <Route path="/cyber-security" element={<CyberSecurityPage />} />
          <Route path="/diagnostic" element={<DiagnosticPage />} />
          <Route path="/diagnostic/auth/callback" element={<PoPAuthCallback />} />

          {/* SAMANVAI Company Intelligence (admin-gated) */}
          <Route path="/company-intelligence" element={<CILanding />} />
          <Route element={<CIShell />}>
            <Route path="/company-intelligence/dashboard" element={<CIDashboard />} />
            <Route path="/company-intelligence/new" element={<CINewAssessment />} />
            <Route path="/company-intelligence/compare" element={<CICompare />} />
            <Route path="/company-intelligence/workspace/:id" element={<CIWorkspace />} />
          </Route>

          {/* Professor of Practice sub-portal */}
          <Route path="/pop"                element={<PoPLanding />} />
          <Route path="/pop/auth/callback"  element={<PoPAuthCallback />} />
          <Route path="/pop/onboarding"     element={<PoPOnboarding />} />
          <Route path="/pop/dashboard"      element={<PoPDashboard />} />
          <Route path="/pop/capstone"       element={<CapstoneDashboard />} />
          <Route path="/pop/capstone/new"   element={<CapstoneNew />} />
          <Route path="/pop/capstone/admin" element={<CapstoneAdmin />} />
          <Route path="/pop/capstone/:id"   element={<CapstoneWorkspace />} />
          <Route path="/pop/directory"      element={<PoPDirectory />} />
          <Route path="/pop/opportunities"  element={<PoPOpportunities />} />
          <Route path="/pop/messages"       element={<PoPMessages />} />
          <Route path="/pop/events"         element={<PoPEvents />} />
          <Route path="/pop/library"        element={<PoPLibrary />} />
          <Route path="/pop/learning"       element={<PoPLearning />} />
          <Route path="/pop/questions"      element={<PoPQuestions />} />
          <Route path="/pop/gaps"           element={<PoPGaps />} />
          <Route path="/pop/books"          element={<PoPBooks />} />
          <Route path="/pop/ai-mba"         element={<PoPAIEnabledMBA />} />
          <Route path="/pop/admin"          element={<PoPAdmin />} />
          </Routes>
        </PoPAuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
